// extracted by mini-css-extract-plugin
module.exports = {"catalog":"ObjectsMapCatalogMobile_catalog__7XJn0","catalogHeader":"ObjectsMapCatalogMobile_catalogHeader__mTt_P"};